import { getHeaders } from "./fetch";

export async function invokeGraphQL(url, query, variables = {}) {
  const body = query(variables);
  const response = await fetch(
    url,
    {
      method: 'POST',
      headers: {
        ...getHeaders(),
        'Content-Type': 'application/json'
      },
      body
    }
  );
  if (!response.ok) {
    throw new Error('Could not complete request');
  }
  const { data, errors } = await response.json();
  if (errors) {
    throw new Error(errors[0].message || 'Could not complete request');
  }
  return data;
}



// WEBPACK FOOTER //
// ./src/services/graphql.js